// extracted by mini-css-extract-plugin
export default {"mapControls":"MapControls_mapControls__qc3S6","mapControlBtn":"MapControls_mapControlBtn__3911z"};